// external imports
import React from 'react'
import { createFragmentContainer, graphql } from 'react-relay'
import { FlexRow, FlexColumn } from 'quark-web'
// local imports
import { Header, Text } from '~/components'
import styles from './styles'

const ProductCharacteristics = ({ product }) => {
    // the object mapping category characteristic keys to product values
    const productCharacteristics = product.characteristics.edges.reduce(
        (prev, { node: characteristic }) => ({
            ...prev,
            [characteristic.key.key]: characteristic.value
        }),
        {}
    )

    return (
        <FlexColumn grow={1} shrink={1} style={{ width: 10, ...styles.characteristics }}>
            <Header style={styles.characteristicsHeader}>characteristics</Header>
            {product.category.characteristicKeys.edges
                .map(({ node: { key } }, i) => (
                    <FlexRow style={i !== 0 && styles.characteristic} key={key}>
                        <FlexRow grow={1} style={{ width: 10 }}>
                            <Text style={styles.characteristicName}>{key}</Text>
                        </FlexRow>
                        <FlexRow grow={1} style={{ width: 10 }}>
                            <Text style={styles.characteristicValue}>{productCharacteristics[key]}</Text>
                        </FlexRow>
                    </FlexRow>
                ))
                .reverse()}
        </FlexColumn>
    )
}

export default createFragmentContainer(
    ProductCharacteristics,
    graphql`
        fragment ProductCharacteristics_product on Product {
            category {
                characteristicKeys {
                    edges {
                        node {
                            key
                        }
                    }
                }
            }
            characteristics {
                edges {
                    node {
                        key {
                            key
                        }
                        value
                    }
                }
            }
        }
    `
)



// WEBPACK FOOTER //
// ./src/components/ProductCharacteristics/index.js